import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltipDummy: {
        id: 'custom.products.CPP.tooltip.Dummy',
        defaultMessage: 'Dummy'
    }
    
})